import { render, staticRenderFns } from "./DeleteDuplicatedClient.vue?vue&type=template&id=4f4ae0ad&scoped=true&"
import script from "./DeleteDuplicatedClient.vue?vue&type=script&lang=js&"
export * from "./DeleteDuplicatedClient.vue?vue&type=script&lang=js&"
import style0 from "./DeleteDuplicatedClient.vue?vue&type=style&index=0&id=4f4ae0ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4ae0ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VForm,VIcon,VTextField})
